import { render, staticRenderFns } from "./StudentProgress.vue?vue&type=template&id=6a2c8a5a&scoped=true"
import script from "./StudentProgress.vue?vue&type=script&lang=js"
export * from "./StudentProgress.vue?vue&type=script&lang=js"
import style0 from "./StudentProgress.vue?vue&type=style&index=0&id=6a2c8a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c8a5a",
  null
  
)

export default component.exports